import { Navigate } from 'react-router-dom';
import Documents from '../core/documents/pages/documents/documents';
import Home from '../core/homepage/pages/home/home';
import Profile from '../core/profile/pages/profile/profile';
import PdfPage from '../core/ui/pdfPage/pdfPage';
import Agreements from '../core/agreements/pages/agreements/agreements';
import AgreementPdfPage from '../core/agreements/pages/agreementPdfPage/agreementPdfPage';
import Login from '../core/login/pages/login/login';
import NotAuthorized from '../core/login/pages/notAuthorized/notAuthorized';
import BasicScreen from '../core/layout/basicScreeen/basicScreen';
import Investors from '../core/investors/pages/investors/investors';
import Impersonate from '../core/impersonate/pages/impersonate/impersonate';
import DocuSignRedirect from '../core/docuSign/pages/docuSignRedirect/docuSignRedirect';
import NoMatch from '../core/ui/noMatch/noMatch';
import BoardsContainer from '../core/dashboards/pages/boards/boardsContainer';
import Board from '../core/dashboards/components/board/board';
import ErrorPage from '../core/errorPage/pages/errorPage/errorPage';

import InvestorBoardsContainer from '../core/dashboards/pages/boards/investorBoardsContainer';
import AgreementDecline from '../core/agreements/pages/agreementDecline/agreementDecline';
import DocuSignResponsive from '../core/docuSign/pages/docuSignResponsive/docuSignResponsive';

const routerConfig = (setAuthorized?: any, setAuthenticated?: any, setShowAgreement?: any, authorized?: any, authenticated?: any, showAgreement?: any) => [
  {
    path: '/',
    element: authenticated ? showAgreement ? <Navigate to="/agreements" /> : authorized ? <BasicScreen /> : <Navigate to="/notAuthorized" /> : <Login />,
    children: [
      { index: true, element: <Home /> },
      {
        path: '/documents',
        element: <Documents />,
      },
      {
        path: '/profile',
        element: <Profile />,
      },
      {
        path: 'documents/pdf/:assignId',
        element: <PdfPage />,
      },
      {
        path: '/impersonate',
        element: <Impersonate />,
      },
      {
        path: '/error',
        element: <ErrorPage />,
      },
      // {
      //   path: '/investors',
      //   element: <Investors />,
      // },
      {
        path: '/boards',
        element: <BoardsContainer />,
        children: [
          {
            path: '/boards/:investorId',
            element: <InvestorBoardsContainer />,
            children: [
              {
                path: '/boards/:investorId/:boardId',
                element: <Board />,
              },
            ],
          },
        ],
      },
      {
        path: '/docusign/sign',
        element: <DocuSignResponsive />
      },
      {
        path: '/docusign/redirect/:recipientId',
        element: authenticated ? (
          showAgreement ? (
            <Navigate to="/agreements" />
          ) : authorized ? (
            <DocuSignRedirect />
          ) : (
            <Navigate to="/notAuthorized" />
          )
        ) : (
          <Login />
        ),
      },
      {
        path: '*',
        element: <NoMatch />,
      },
    ],
  },
  {
    path: '/agreements',
    element: authenticated ? <Agreements setShowAgreemnt={setShowAgreement} /> : <Login />,
  },
  {
    path: '/agreements/:assignId',
    element: authenticated ? <AgreementPdfPage setShowAgreement={setShowAgreement} /> : <Login />,
  },
  {
    path: '/agreements/declined',
    element: authenticated ? <AgreementDecline /> : <Login />,
  },

  {
    path: '/notAuthorized',
    element: <NotAuthorized />,
  },
];

export default routerConfig;
